import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {Admin} from "./models/admin";
import {AdminService} from "./services/admin.service";
import {PasswordValidation} from "./services/admin.service";
import {ActivatedRoute, Router} from "@angular/router";
declare var $: any;

@Component({
    selector: 'app-addadmin',
    templateUrl: './addadmin.component.html'
})
export class AddadminComponent implements OnInit {
    title:string = "Add admin";
    iAdminId = 0;
    adminform: FormGroup;
    admininfo: Admin;
    isEdit: boolean = false;
    ckeditorContent;
    constructor(
        private adminService:AdminService,
        private router: Router,
        private fb: FormBuilder,
        private activatedRoute: ActivatedRoute,
    ) {
        activatedRoute.params.subscribe(params => {
            this.iAdminId = params["id"];
        });
        if(this.iAdminId > 0){
            this.isEdit = true;
        }
        if(this.iAdminId > 0){
            this.title = "Edit Profile";
        }
    }

    ngOnInit() {
        this.title;
        this.isEdit;
        this.adminform = this.fb.group({
            emailid: ['',
                Validators.required
            ],
            password:['',
                Validators.required
            ],
            vConfirmPassword:['',
                Validators.required
            ],
        }, {
            validator: PasswordValidation.MatchPassword // your validation method
        });

        if (this.isEdit) {
            this.getAdminInfo();
        }
        //this.loadScriptLibrary();
    }

    onSubmit(adminValue) {
        if(this.isEdit){
            this.updateForm(adminValue);
        }else{
            this.addForm(adminValue);
        }
    }

    addForm(adminValue){
        $('#save_admin').button('loading');
        this.adminService.createAdmin(adminValue).then(AdminData => {
            if(AdminData['status'] === 200){
                $('#save_admin').button('reset');
                $.toast({heading: 'Success', text: AdminData['msg'], position: 'top-right', showHideTransition: 'slide', icon: 'success'});
                this.router.navigate(['/admins']);
            }else{
                $.toast({heading: 'Warning', text: AdminData['msg'], position: 'top-right', showHideTransition: 'slide', icon: 'warning'});
                $('#save_admin').button('reset');
            }
        }).catch(err => {
            if(err['status'] != 200){
                $.toast({heading: 'Error', text: err['msg'], position: 'top-right', showHideTransition: 'slide', icon: 'error'});
            }else{
                $.toast({heading: 'Error', text: 'Server error! Please try again later', position: 'top-right', showHideTransition: 'slide', icon: 'error'});
            }
            $('#save_admin').button('reset');
        });
    }

    updateForm(adminValue){
        $('#update_admin').button('loading');
        adminValue['iAdminId'] = this.iAdminId;
        this.adminService.updateAdmin(adminValue).then(AdminData => {
            if(AdminData['code'] === 200){
                $('#update_admin').button('reset');
                $.toast({heading: 'Success', text: AdminData['message'], position: 'top-right', showHideTransition: 'slide', icon: 'success'});
                this.router.navigate(['/admins']);
            }else{
                console.log(AdminData['message']);
                $.toast({heading: 'Warning', text: AdminData['message'], position: 'top-right', showHideTransition: 'slide', icon: 'warning'});
                $('#update_admin').button('reset');
            }
        }).catch(err => {
            if(err['status'] != 200){
                $.toast({heading: 'Error', text: err['message'], position: 'top-right', showHideTransition: 'slide', icon: 'error'});
            }else{
                $.toast({heading: 'Error', text: 'Server error! Please try again later', position: 'top-right', showHideTransition: 'slide', icon: 'error'});
            }
            $('#update_admin').button('reset');
        });
    }

    getAdminInfo=function () {
        this.adminService.getAdminInfo(this.iAdminId).then(data => {
            console.log("AdminInfo=======>",data['data']);
            this.admininfo = data['data'];
            this.patchForm();
        });
    }

    patchForm() {
        console.log("AdminInfoDetails=======>"+this.admininfo.emailid)
        this.adminform.patchValue({
            emailid: this.admininfo.emailid,
            // vSlug: this.admininfo.vSlug,
            // tDescription:this.admininfo.Description,
        })
    }

    public loadScriptLibrary() {
        let body = <HTMLDivElement> document.body;
        let script = document.createElement('script');
        script.innerHTML = '';
        script.src = 'assets/adminlte/plugins/ckeditor/ckeditor.js';
        body.appendChild(script);

        let body2 = <HTMLDivElement> document.body;
        let script2 = document.createElement('script');
        script2.innerHTML = 'CKEDITOR.replace( \'tDescription\' );';
        body2.appendChild(script2);
    }
}



// WEBPACK FOOTER //
// /home/sotsys211/work/src/ecard_new/backend/src/app/admin/addadmin.component.ts